import React, { useState, useEffect  } from "react"
import { useUndoRedo, useGetPolygons } from "../../polygonLib";


import "./Toolbar.css"

const Toolbar = ({
  maxPolygons,
  //updatePolygonState,
  deleteState,
  setSelectPolygon,
  showLabel,
  setMaxPolygons,
  setShowLabel,
  config,
  setConfig,
  title
}) => {
  const { undo, redo, canUndo, canRedo } = useUndoRedo()
  const { polygons, polygonsPoints, updateLabel, deletePolygons } = useGetPolygons();
  sessionStorage.setItem("polygonsPoints", JSON.stringify(polygonsPoints));
  const [fillColor, setFillcolor] = useState("#37f711")
  const [updatePolygon, setUpdatePolygon] = useState(polygonsPoints);
useEffect(()=>{
  if(deleteState) {
    deletePolygons();
  }
}, [deleteState])

  return (
    <></>
  )
}

export default Toolbar
